//= encoding UTF-8
import 'public-path';
import 'stylesheets/styles.css';
import 'stylesheets/styles.scss';

import { enableProdMode } from '@angular/core';
import { AppModule } from '@app/app.module';
import { platformBrowser } from '@angular/platform-browser';
import 'app/utils/SCC2PaymentPage.js';
import 'app/utils/ShippingTypeUtils.js';
import 'app/store/VisualMerchandiseStore.js';
import 'app/store/UserProfileStore.js';
import 'app/store/SubjectStore.js';
import 'app/store/StepperProgressStore.js';
import 'app/store/SmileSafeStore.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/SelectionTemplateDataStore.js';
import 'app/store/RewardStore.js';
import 'app/store/ProductCatalogStore.js';
import 'app/store/OrderStatusStore.js';
import 'app/store/MessageStore.js';
import 'app/store/LooksStore.js';
import 'app/store/JobStore.js';
import 'app/store/DigitalDownloadStore.js';
import 'app/store/data/enhancement/enhancement.store.ts';
import '@app/service/season/LookAllowlistService';
import 'app/store/ContentStore.js';
import 'app/service/YearbookInfoService.js';
import 'app/service/ValidationService.js';
import 'app/interceptor/user/profile/UserProfileInterceptor.js';
import 'app/service/UIService.js';
import 'app/service/TranslationFactory.js';
import 'app/service/TranslateProviderService.js';
import 'app/service/SuggestedProductService.js';
import 'app/service/StorageService.js';
import 'app/service/StatsdService.js';
import 'app/service/StatesService.js';
import 'app/service/StandardizedEnhancementService.js';
import 'app/service/SmileSafeService.js';
import 'app/service/SessionTimeoutService.js';
import 'app/interceptor/session/timeout/SessionTimeoutInterceptor.js';
import 'app/service/SchoolsService.js';
import 'app/service/RouterService.js';
import 'app/service/RouteCacheService.js';
import 'app/service/RedirectionService.js';
import 'app/service/qHelperService.js';
import 'app/service/PostalCodeValidationService.js';
import 'app/service/PortraitIdFormatterService.js';
import 'app/service/PackageBundleService.js';
import 'app/service/OrderStatusService.js';
import 'app/service/OrdersService.js';
import 'app/service/OrderLineFactory.js';
import 'app/service/OrderFormService.js';
import 'app/service/MasterSubjectService.js';
import 'app/service/LtPictureDayFormCtrlService.js';
import 'app/service/LoginPopupService.js';
import 'app/service/JobCleanUpService.js';
import 'app/service/ItemService.js';
import '@app/service/common/ProductService';
import '@app/service/student-banner.service';
import 'app/service/InitService.js';
import 'app/service/IdentityService.js';
import 'app/interceptor/identity/IdentityInterceptor.js';
import 'app/interceptor/http/timeout/HttpTimeoutInterceptor.js';
import 'app/service/GuidGenerator.js';
import 'app/service/GradeService.js';
import 'app/service/EventService.js';
import 'app/service/EventDataService.js';
import 'app/service/ErrorLogService.js';
import 'app/service/FlightRecorderService.js';
import 'app/service/EmailValidationService.js';
import 'app/service/ContentJobTypeMappingService.js';
import 'app/service/ConfirmSchoolService.js';
import 'app/service/CommonService.js';
import 'app/service/ColorService.js';
import 'app/service/ShippingTypeService';
import 'app/service/CitiesService.ts';
import 'app/service/CheckoutService.js';
import 'app/service/CachedArrayDataFactory.js';
import 'app/service/BlockService.js';
import 'app/service/AppVersionUpdateService.js';
import 'app/service/AnalyticsService.js';
import 'app/service/AddVerifiedSubjectService.js';
import 'app/service/AddressValidationService.js';
import 'app/service/AddressConsistencyService.js';
import 'app/service/AddOnService.js';
import 'app/service/session-storage.service';
import 'app/i18n/localeFRCA.js';
import 'app/i18n/localeESUS.js';
import 'app/i18n/localeENUS.js';
import 'app/filter/SpecialCharacterValidationFilter.js';
import 'app/filter/LtTranslateFilter.js';
import 'app/filter/LtSubjectWithEventFilter.js';
import 'app/filter/LtSelectionTemplateFieldTranslateFilter.js';
import 'app/filter/LtFormatToHtmlFilter.js';
import 'app/filter/LtDateOnlyFilter.js';
import 'app/filter/ItemDescFilter.js';
import 'app/filter/CurrencyLocaleFilter.js';
import 'app/filter/ContentFilter.js';
import 'app/filter/CapitalizationFilter.js';
import 'app/directive/UpSellMessageDirective.js';
import 'app/directive/UpsellMessageCtrl.js';
import 'app/directive/PasswordStrengthMeterDirective.js';

import 'app/directive/LtWelcomeDirective.js';
import 'app/directive/LtWelcomeCtrl.js';
import 'app/directive/LtUpperCaseDirective.js';
import 'app/directive/LtTranslateSrcDirective.js';
import 'app/directive/LtTranslateDirective.js';
import 'app/directive/LtTextPersonalizerDirective.js';
import 'app/directive/LtTextPersonalizerCtrl.js';
import 'app/directive/LtStudentPortraitInformationDirective.js';
import 'app/directive/LtStudentPortraitInformationCtrl.js';
import 'app/directive/LtStudentIdLoginDirective.js';
import 'app/directive/LtStepperProgressDirective.js';
import 'app/directive/LtStepperProgressCtrl.js';
import 'app/directive/LtSoftMatchFormDirective.js';
import 'app/directive/LtSoftMatchFormCtrl.js';
import 'app/directive/LtShoppingCartSummaryDirective.js';
import 'app/directive/LtShoppingCartSummaryCtrl.js';
import 'app/directive/LtSelectSheetDrawerDirective.js';
import 'app/directive/LtSelectSheetDrawerCtrl.js';
import 'app/directive/LtSelectLookDrawer2Directive.js';
import 'app/directive/LtSelectionTemplateFieldDirective.js';
import 'app/directive/LtSelectionTemplateFieldCtrl.js';
import 'app/directive/LtSelectFocusDirective.js';
import 'app/directive/LtSelectEnhancementsDirective.js';
import 'app/directive/LtSelectEnhancementsCtrl.js';
import 'app/directive/LtScrollableDirective.js';
import 'app/directive/LtScrollableCtrl.js';
import 'app/directive/LtSchoolSearchDirective.js';
import 'app/directive/LtSchoolSearchCtrl.js';
import 'app/directive/LtSaveAlertDirective.js';
import 'app/directive/LtSaveAlertCtrl.js';
import 'app/directive/LtAddressConfirmationCtrl.js';
import 'app/directive/LtAddressConfirmationDirective';
import 'app/directive/LtRadioDirective.js';
import 'app/directive/LtPromoZoneCarouselDirective.js';
import 'app/directive/LtPromoZoneCarouselCtrl.js';
import 'app/directive/LtPromiseDirective.js';
import 'app/directive/LtProductCategoryFilterDirective.js';
import 'app/directive/LtProcessingDialogDirective.js';
import 'app/directive/LtPriceDirective.js';
import 'app/directive/LtPotraitGalleryDirective.js';
import 'app/directive/LtPotraitGalleryCtrl.js';
import 'app/directive/LtPostalCodeValidationDirective.js';
import 'app/directive/LtPortraitPictureDayIdInputDirective.js';
import 'app/directive/LtPortraitPictureDayIdInputCtrl.js';
import 'app/directive/LtPictureDayFormDirective.js';
import 'app/directive/LtPictureDayFormCtrl.js';
import 'app/directive/LtPictureDayDateDirective.js';
import 'app/directive/LtPictureDayAnotherStudentFormDirective.js';
import 'app/directive/LtPhotoDayRedirection.js';
import 'app/directive/LtPayOnlySummaryDirective.js';
import 'app/directive/LtPayOnlySummaryCtrl.js';
import 'app/directive/LtPayOnlyDetermineAmountDrawerDirective.js';
import 'app/directive/LtPayOnlyDetermineAmountDrawerCtrl.js';
import 'app/directive/LtPasswordValidationDirective.js';
import 'app/directive/LtPackageSummaryDirective.js';
import 'app/directive/LtPackageSummaryCtrl.js';
import 'app/directive/LtOutsideClickDirective.js';
import 'app/directive/LtOrderSummaryZeroStateDirective.js';
import 'app/directive/LtOrderSummaryZeroStateCtrl.js';
import 'app/directive/LtOrderSummaryStepTwoDirective.js';
import 'app/directive/LtOrderSummaryStepTwoCtrl.js';
import 'app/directive/LtOrderSummaryDirective.js';
import 'app/directive/LtOrderSummaryCtrl.js';
import 'app/directive/LtOrderStatusDrawerDirective.js';
import 'app/directive/LtOrderStatusDrawerCtrl.js';
import 'app/directive/LtOrderStatusBannerDirective.js';
import 'app/directive/LtOrderStatusBannerCtrl.js';
import 'app/directive/LtOrderReceiptChildSummaryDirective.js';
import 'app/directive/LtOrderReceiptChildSummaryCtrl.js';
import 'app/directive/LtOrderMoreDrawerDirective.js';
import 'app/directive/LtOrderMoreDrawerCtrl.js';
import 'app/directive/LtOnInputPauseDirective.js';
import 'app/directive/LtNumericOnlyDirective.js';
import 'app/directive/LtMyFavouriteDirective.js';
import 'app/directive/LtMyFavouriteCtrl.js';
import 'app/directive/LtLookLoaderDirective.js';
import 'app/directive/LtLookCarouselDirective.js';
import 'app/directive/LtLookCarouselCtrl.js';
import 'app/directive/LtLoginPopupDirective.js';
import 'app/directive/LtLoginPopupCtrl.js';
import 'app/directive/LtLifetouchCodeGuestLoginDirective.js';
import 'app/directive/LtLifetouchCodeGuestLoginCtrl.js';
import 'app/directive/LtLifetouchCodeFormDirective.js';
import 'app/directive/LtLifetouchCodeFormCtrl.js';
import 'app/directive/LtKeyFilterDirective.js';
import 'app/directive/LtJobLoadFailedDrawer.js';
import 'app/directive/LtInstantPromoPopupDirective.js';
import 'app/directive/LtInstantPromoPopupCtrl.js';
import 'app/directive/LtInfoButtonDirective.js';
import 'app/directive/LtImageOrientationClassDirective.js';
import 'app/directive/LtGuestSignInDirective.js';
import 'app/directive/LtGuestSignInCtrl.js';
import 'app/directive/LtFormChangeDirective.js';
import 'app/directive/LtFocusDirective.js';
import 'app/directive/LtExpandableBannerDirective.js';
import 'app/directive/LtExpandableBannerCtrl.js';
import 'app/directive/LtEqualityValidationDirective.js';
import 'app/directive/LtEnlargeLookDrawerDirective.js';
import 'app/directive/LtEnlargeLookDrawerCtrl.js';
import 'app/directive/LtEnhancementsDirective.js';
import 'app/directive/LtEnhancementsCtrl.js';
import 'app/directive/LtEnhancedPayOnlySummaryDirective.js';
import 'app/directive/LtEnhancedPayOnlySummaryCtrl.js';
import 'app/directive/LtEnhancedPayonlyContinueShoppingDirective.js';
import 'app/directive/LtEnhancedPayonlyContinueShoppingCtrl.js';
import 'app/directive/LtEmailOptionDirective.js';
import 'app/directive/LtDrawerDirective.js';
import 'app/directive/LtCyopSummaryDirective.js';
import 'app/directive/LtCyopSummaryCtrl.js';
import 'app/directive/LtCyopDirective.js';
import 'app/directive/LtCyopCtrl.js';
import 'app/directive/LtCyodPopupDirective.js';
import 'app/directive/LtCyodPopupCtrl.js';
import 'app/directive/LtCustomSheetDirective.js';
import 'app/directive/LtCustomizeLookSelectionDirective.js';
import 'app/directive/LtCustomizeLookSelectionCtrl.js';
import 'app/directive/LtContentItemDirective.js';
import 'app/directive/LtConfirmStudentInfoDrawerDirective.js';
import 'app/directive/LtConfirmStudentInfoDrawerCtrl.js';
import 'app/directive/LtConfirmRedirectDirective.js';
import 'app/directive/LtConfirmExistingStudentDirective.js';
import 'app/directive/LtConfirmExistingStudentCtrl.js';
import 'app/directive/LtConfirmDirective.js';
import 'app/directive/LtConfirmDeleteDrawerDirective.js';
import 'app/directive/LtConfirmDeleteDrawerCtrl.js';
import 'app/directive/LtClickDirective.js';
import 'app/directive/LtChooseSpecOrderDrawerDirective.js';
import 'app/directive/LtChooseSpecOrderDrawerCtrl.js';
import 'app/directive/LtCheckOutWithPayPalButtonDirective.js';
import 'app/directive/LtCheckOutWithPayPalButtonCtrl.js';
import 'app/directive/LtCheckoutProgressDirective.js';
import 'app/directive/LtCheckboxDirective.js';
import 'app/directive/LtCardOffersDirective.js';
import 'app/directive/LtCardOffersCtrl.js';
import 'app/directive/LtBrowseAndSelectLookDrawerCtrl.js';
import 'app/directive/LtBillingFieldMessagesDirective.js';
import 'app/directive/LtAutoSrcDirective.js';
import 'app/directive/LtAppVersionUpdate.js';
import 'app/directive/LtAddressValidationDirective.js';
import 'app/directive/LtAddonZoomDrawerDirective.js';
import 'app/directive/LtAddonZoomDrawerCtrl.js';
import 'app/directive/LtAddOnDetailSummaryDirective.js';
import 'app/directive/LtAddOnDetailSummaryCtrl.js';
import 'app/directive/LtAddonCarouselDirective.js';
import 'app/directive/LtAddonCarouselCtrl.js';
import 'app/directive/LtAddNewStudentDirective.js';
import 'app/directive/LtAddNewStudentCtrl.js';
import 'app/directive/GlobalMessagesDirective.js';
import 'app/directive/GlobalMessagesCtrl.js';
import 'app/controller/LoginCtrl.js';
import 'app/controller/HomeCtrl.js';
import 'app/controller/HeaderCtrl.js';
import 'app/controller/GetStartedCtrl.js';
import 'app/controller/FooterCtrl.js';
import 'app/controller/FailureMessageCtrl.js';
import 'app/constant/SiteSectionConstants.js';
import 'app/constant/ShoppingCartConstants.js';
import 'app/constant/ResourceConstants.js';
import 'app/constant/PageNameConstants.js';
import 'app/constant/MasterSubjectUserProfileXrefStatusConstants.js';
import 'app/constant/FailureTypeConstants.js';
import 'app/constant/CacheConstants.js';
import 'app/components/AddOnItemComponent.js';
import 'app/action/SessionTimeoutAction.js';
import 'app/action/ResetJobAction.js';
import 'app/action/MessageChangeAction.js';
import 'app/action/LogoutSuccessAction.js';
import 'app/action/LoginSuccessAction.js';
import 'app/action/LocaleChangeAction.js';
import 'app/action/JobLoadFailedAction.js';
import 'app/action/JobLoadedAction.js';
import 'app/action/EmptyCartAction.js';
import 'app/action/DeserializeAction.js';
import 'app/action/ContentChangeAction.js';
import 'app/action/ChangeActiveOrderAction.js';
import 'app/action/ActiveJobChangedAction.js';
import 'app/account/CreateAccountCtrl.js';
import 'app/service/payment/PaymentService.js';
import 'app/service/AddNewStudentFormSubmissionService.js';
import '@app/service/DeviceService';
import 'app/components/lt-delivery-pill/lt-delivery-pill.js';
import '@app/service/common/PersistentCartService.js';
import '@app/service/common/PersistentCartPreprocessorService.ts';
import 'app/components/breadcrumb/breadcrumb.js';
import 'app/components/core/flag-label/flag-label.js';
import 'app/service/logger.service.ts';
import 'app/service/routeLogging.ts';
import 'app/interceptor/http/error/httpInterceptor.ts';
import 'app/service/globalErrorHandler.ts';
import 'app/components/cart-reward-tracker/cart-reward-tracker.component';
import '@app/service/ConfettiService.js';
import '@app/components/core/alert/alert.component.ts';
import '@app/service/migration-helpers/angularjs.downgrade';
import '@app/components/shopping-flow-bar/shopping-flow-bar.component';
import '@app/components/student-banner/student-banner.component';
import '@app/components/student-chiclet/student-chiclet.component';
import '@app/components/student-chiclet-bar/student-chiclet-bar.component';
import '@app/modules/page-header/page-header.component'
import '@app/service/account/AccountApi';
import '@app/components/core/lt-button/lt-button.component';
import '@app/service/digital-download-icon/digital-download.service';

/*global def */
(async () => {
  if (process.env.NODE_ENV === 'production') {
    enableProdMode();
  } else {
    await import('@angular/compiler')
  }

  platformBrowser()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
})();
